import React from 'react'
import { motion } from "framer-motion";
import NavigationButton from './NavigationButton';

const Intro = () => {
  return (
    <motion.div initial={{ opacity: 0}} whileInView={{ opacity: 1}}  transition={{ delay: 0.2, duration: 2}} >
          <section id="intro" className="section-image-bg">
              <div className="row section-full-frame d-flex justify-content-center align-items-center section-diviser">
                  <div className="col-sm-12 col-md-6 d-flex flex-column justify-content-between align-items-center h-100">
                      <NavigationButton mySelector="#hero" myIcon="chevron-up" hasMargin={true}/>
                      <article className="px-5 px-md-0">
                        <h1 className="title display-3 mb-3 text-center">The Rustic House</h1>
                        <p>Seize bricks-and-clicks weblogs design real-time post--vertical syndicate, "methodologies architect back-end transparent syndicate action-items communities, rss-capable, wireless; e-markets innovative channels action-items enable innovative, ecologies engage syndicate holistic post.</p>
                        <p>Channels, action-items, open-source viral; users e-tailers, eyeballs front-end best-of-breed supply-chains seamless users innovative; interactive.</p>
                        <p>Robust, embedded, platforms optimize end-to-end citizen-media aggregate drive schemas disintermediate platforms podcasts morph. Redefine engage compelling strategic podcasting, "portals e-business," networkeffects envisioneer orchestrate e-tailers ROI redefine value e-commerce transition.</p>
                      </article>
                      <NavigationButton mySelector="#main-image" myIcon="chevron-down" hasMargin={true}/>
                  </div>
              </div>
          </section>
     </motion.div>
  )
}

export default Intro
